import { Pipe, PipeTransform } from "@angular/core";
import { localize } from "@gtmhub/localization";

@Pipe({
  name: "repliesCount",
  standalone: true,
})
export class RepliesCountPipe implements PipeTransform {
  public transform(repliesCount: number): string {
    if (!repliesCount) {
      return localize("there_are_no_replies_yet");
    }

    if (repliesCount === 1) {
      return localize("one_reply");
    }

    const countText = repliesCount > 10 ? "10+" : repliesCount.toString();
    return localize("n_replies", { count: countText });
  }
}
